import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import StatsSection from './StatsSection'
// import OurServices from './OurServices'
import WhyChooseUsNewSection from './WhyChooseUsNew'
// import MultimodalServiceSection from './MultimodalServiceSection'
import LogisticsServicesHero from './LogisticsServicesHero'
import CoreValuesPage from './CoreValuesPage'
// import BlogPage from './BlogPageSection'
import Commitment from './OurCommitment'
import IndustryExpertisePage from './IndustryExpertise'
import { useNavigate } from 'react-router-dom'
import NewHeroImage from '../assets/images/data/new_hero.png'
import NewHeroMobileImage from '../assets/images/data/Mobile-Hero.png'
import FooterPage from './FooterPage'

const Home = () => {
  const [trackingNumber, setTrackingNumber] = useState('')
  const navigate = useNavigate()

  const handleTrackingSubmit = e => {
    e.preventDefault()
    const trimmed = trackingNumber.trim()
    if (!trimmed) return

    // navigate to the v2 tracking page
    navigate(`/track-shipment-v2/${trimmed}`)
  }

  return (
    <div className='min-h-screen bg-white'>
      <Helmet>
        <title>
          S Infinite Express | Trusted Logistics & Transport Solutions Across
          India
        </title>

        <meta
          name='description'
          content='S Infinite Express provides reliable logistics, transportation, LTL, FTL, 3PL, express delivery, cold chain, international shipping, and warehousing solutions across India.'
        />

        <meta
          name='keywords'
          content='S Infinite Express, logistics company India, transport services India, freight transportation, LTL logistics, FTL transportation, 3PL logistics, express delivery, cold chain logistics, international shipping, warehousing services, cargo tracking, supply chain solutions, logistics partner India'
        />

        <meta name='robots' content='index, follow' />

        <link rel='canonical' href='https://sinfiniteexpress.com/' />

        {/* Open Graph */}
        <meta
          property='og:title'
          content='S Infinite Express | Trusted Logistics Partner'
        />

        <meta
          property='og:description'
          content='Experience reliable delivery and smart logistics solutions with S Infinite Express. Your trusted logistics partner across India and beyond.'
        />

        <meta property='og:url' content='https://sinfiniteexpress.com/' />

        <meta property='og:type' content='website' />

        <meta
          property='og:image'
          content='https://sinfiniteexpress.com/assets/images/data/new_hero.png'
        />

        <meta property='og:site_name' content='S Infinite Express' />

        {/* Twitter SEO */}
        <meta name='twitter:card' content='summary_large_image' />

        <meta
          name='twitter:title'
          content='S Infinite Express | Logistics & Transportation'
        />

        <meta
          name='twitter:description'
          content='Fast, reliable delivery and smart logistics solutions across India and beyond.'
        />

        <meta
          name='twitter:image'
          content='https://sinfiniteexpress.com/assets/images/data/new_hero.png'
        />
      </Helmet>

      {/* Hero Section */}
      <div className='relative min-h-[55vh] sm:min-h-[60vh] md:min-h-[65vh] flex items-center overflow-hidden'>
        {/* Background Image - Desktop */}
        <div
          className='hidden md:block absolute inset-0 bg-cover bg-center scale-105'
          style={{ backgroundImage: `url(${NewHeroImage})` }}
        />

        {/* Background Image - Mobile */}
        <div
          className='block md:hidden absolute inset-0 bg-cover bg-top'
          style={{ backgroundImage: `url(${NewHeroMobileImage})` }}
        />

        {/* Overlay */}
        <div className='absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 via-45% to-transparent'></div>

        {/* Content */}
        <div className='relative z-10 max-w-7xl mx-auto px-6 py-12 sm:py-16 md:py-24 grid lg:grid-cols-2 gap-12 items-center'>
          {/* LEFT CONTENT */}
          <div className='text-white space-y-6 lg:max-w-xl'>
            <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-snug sm:leading-tight lg:leading-tight tracking-tight'>
              <span className='block'>
                <span className='text-red-500'>Experience </span>
                <span className='drop-shadow-lg text-[#fff44f]'>On-Time</span>
              </span>
              <span className='block drop-shadow-lg text-[#fff44f] text-2xl sm:text-3xl md:text-4xl lg:text-5xl'>
                Delivery, Every Time
              </span>
            </h1>

            <p className='text-base sm:text-lg md:text-xl text-gray-200 font-medium'>
              Your trusted partner for fast, reliable delivery and smart
              logistics solutions across India and beyond, every single day.
            </p>

            {/* CTA / Tracking Input */}
            <div className='mt-6 sm:mt-8 flex flex-col sm:flex-row gap-4'>
              <div className='flex-1'>
                <input
                  type='text'
                  placeholder='Enter LR / Tracking Number'
                  value={trackingNumber}
                  onChange={e => setTrackingNumber(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleTrackingSubmit(e)}
                  className='w-full h-12 sm:h-14 px-4 sm:px-6 rounded-full border border-gray-300 focus:ring-4 focus:ring-red-100 focus:border-red-500 outline-none text-black text-base transition sm:text-base'
                />
              </div>
              <button
                onClick={handleTrackingSubmit}
                className='w-full sm:w-auto bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-6 h-12 sm:h-14 rounded-full font-semibold shadow-lg transition-all hover:-translate-y-0.5 text-sm sm:text-base'
              >
                Track
              </button>
            </div>
            {/* Trust indicators */}
            <div className='mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs font-medium text-white/80 sm:text-sm'>
              <span className='flex items-center gap-2'>
                <span className='text-[#fff44f]'>✓</span>
                Reliable Deliveries
              </span>
              <span className='flex items-center gap-2'>
                <span className='text-[#fff44f]'>✓</span>
                Real-Time Tracking
              </span>
              <span className='flex items-center gap-2'>
                <span className='text-[#fff44f]'>✓</span>
                Smart Fulfillment
              </span>
            </div>
          </div>
        </div>
      </div>

      <StatsSection />
      <WhyChooseUsNewSection />
      {/* <MultimodalServiceSection /> */}
      <LogisticsServicesHero />
      {/* <OurServices /> */}
      <IndustryExpertisePage />
      <CoreValuesPage />
      <Commitment />
      {/* <CommitmentExcellence /> */}
      {/* <BlogPage /> */}
      <FooterPage />
    </div>
  )
}

export default Home
